<template>
  <div class="foters">
    <div class="form">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start" >
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="账户编号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入账户编号"
                v-model="conditionLike.accountNo"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="账户名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入账户名称"
                v-model="conditionLike.accountName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl2 fw">
            <a-form-item 
              label="兑换状态"    
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :allowClear="true"
                v-model="conditionLike.recStatus"
                placeholder="请选择兑换状态"
              >
                <a-select-option v-for="item in billstatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl3 fw">
            <a-form-item 
              label="提交日期"    
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol">
              <a-locale-provider :locale="locale">
                <a-date-picker @change="onChange" v-model="conditionLike.createTime"/>
              </a-locale-provider>
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="padding-top: 2.4%;margin-left: 12px;">
            <a-button class="btone" @click="queryList(1) ">查询</a-button>
          </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <div>
        <a-table
          :columns="columns"
          :scroll="{ x: 1000, y: 'calc(100vh - 340px)' }"
          :data-source="tableData"
          :pagination="false"
          :loading="Tableloading"
          :rowKey="
            (record, index) => {
              return record.id
            }
          "
          bordered
          size="small"
          
        >
          <span slot="index" slot-scope="text, record, index">
            {{index + (pageNum-1) * pageSize + 1}}
          </span>
          <span slot="recStatus" slot-scope="text, record">
            <span v-if="record.recStatus == 2"><a-badge color="cyan" /></span>
            <span v-else-if="record.recStatus == 1"><a-badge color="orange" /></span>
            {{ record.recStatus | DictionaryFilter('EXCHANGE_STATUS') }}
          </span>
          <div slot="action" slot-scope="text" v-if = "text.recStatus ==1">
            <a-button style="margin-left: 8px" class="btaction" @click="modificateRefuse(text)">
                关闭</a-button>
          </div>
        </a-table>
      </div>
      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPage }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :current="pageNum"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <addModal
      v-if="visibleAdd"
      :visible="visibleAdd"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></addModal>
  </div>
</template>

<script>
import {
  queryExchange
} from '@/api/api.js'
import { DictionaryService } from '@common/services/dictionary.service'
//设置中文
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import addModal from './equity-exchange-modal.vue';
export default {
  name: 'figuresManagement',
  components: {
    addModal: addModal,
  },
  data() {
    return {
      locale: zhCN,
      displayAction: false,
      formLayout: 'horizontal',
      billstatusList:[],
      conditionLike: {
        accountNo: '',
        accountName: '',
        recStatus: undefined,
        createTime: undefined,
      },
      Tableloading: false,
      tableData: [],
      querying: false,
      staing: false,
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: 'index',
          width: 23, key: 'index',
          ellipsis: true,
          scopedSlots: { customRender: 'index' }
          
        },
        {
          title: '申请编号',
          align: "center",
          dataIndex: 'recNo',
          width: 60, key: 'recNo',
          ellipsis: true,
          scopedSlots: { customRender: 'recNo' }
          
        },
  
        {
          title: '兑换权益商品',
          align: 'center',
          dataIndex: 'goodName',
          width: 77,
          key: 'goodName',
          ellipsis: true,
          scopedSlots: { customRender: 'goodName' },
        },
        {
          title: '提交日期',
          align: 'center',
          dataIndex: 'createTime',
          width: 70,
          key: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '账户姓名',
          align: 'center',
          dataIndex: 'accountName',
          width: 40,
          key: 'accountName',
          ellipsis: true,
          scopedSlots: { customRender: 'accountName' },
        },
        {
          title: '账户编号',
          align: 'center',
          dataIndex: 'accountNo',
          width: 50,
          key: 'accountNo',
          ellipsis: true,
          scopedSlots: { customRender: 'accountNo' },
        },
        {
          title: '兑换状态 ',
          align: 'center',
          dataIndex: 'recStatus',
          width: 50,
          key: 'recStatus',
          ellipsis: true,
          scopedSlots: { customRender: 'recStatus' },
        },
        {
          title: '备注 ',
          align: 'center',
          dataIndex: 'remark',
          width: 90,
          key: 'remark',
          ellipsis: true,
          scopedSlots: { customRender: 'remark' },
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          width:40,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // // 分页相关
      pageNum: 1,
      pageSize: 10,
      totalRows: null,
      totalPage: '',
      //新增弹框
      visibleAdd: false,
      userData: {},
      type: '',
    }
  },
  activated() {
    //查询数据字典
    DictionaryService.getAllNeedDic(["EXCHANGE_STATUS"]).then((res) => {
      this.billstatusList = DictionaryService.getOptions("EXCHANGE_STATUS");

      //查询列表
      this.queryList();
    });
  },
  mounted() {
    
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {}
    },
    buttonItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {}
    },
  },
  methods: {
    //消费时间
    onChange(date, dateString) {
      this.conditionLike.createTime = dateString;
    },
    // 分页修改
    changePageFn(event) {
      this.pageNum = event
      this.queryList()

    },
    // 获取表格数据
    queryList(sum = 2) {
      if (sum == 1) this.pageNum = 1
      this.Tableloading = true
      let pageParam = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderBy: '',
      }
      queryExchange({ pageParam: pageParam, content: this.conditionLike }).then(
        (res) => {
          this.Tableloading = false
          this.tableData = res.content.rows
          this.totalRows = res.content.page.totalRows
          this.totalPage = Math.ceil(this.totalRows / this.pageSize)
        },
        (err) => {
          this.$message.error('查询失败')
          this.Tableloading = false
        }
      )
    },
    //更多操作-关闭
    modificateRefuse(data) {
        this.visibleAdd = true
        this.type = "refuse"
        this.userData = data
        this.title = '关闭记录' 
    },
    // 关闭弹窗
    reflush(value) {
      this.visibleAdd = value
    },
  }
}
</script>

<style lang="less" scoped="scoped">
.foters {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 100px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 12px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}

/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/deep/ .form .ant-input,.ant-select,.ant-form-item-control,.ant-form-item-control-wrapper{
  width: 160px;
}
.fw {
  width: 236px;
}
.oper{
  // flex: 1;
  width: 200px;
}
.plan{
  width: 350px;
}
.ant-row{
  display: flex;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1){
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1){
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1){
  width: 75px;
}
/deep/ .fl3 .ant-row .ant-col-6:nth-child(1){
  width: 80px;
}
/deep/ .ant-col-18 {
  width: 75%;
}
</style>
